 import React from "react"

const ProjectBack = ({ name, title, cover }) => {
  return (
    <>
      <div className='ProjectBack'>
        <div className='container'>
          <span>{name}</span>
          <h1>{title}</h1>
        </div>
        <img src={cover} alt='' />
      </div>
    </>
  )
}

export default ProjectBack
